import React from "react";
import glamorous from "glamorous";
import Colors from "../../styles/colors";
import { ExceptionDonutChart } from "./ExceptionDonutChart";

import Hourglass from "react-icons/lib/md/hourglass-empty";
import Clock from "react-icons/lib/md/timer";
import Pickup from "react-icons/lib/md/file-upload";
import Dropoff from "react-icons/lib/md/file-download";
import Error from "react-icons/lib/md/error-outline";
import Lock from "react-icons/lib/md/lock-outline";
import Check from "react-icons/lib/md/check";

// Constants
export const TRAILER_EXCEPTION_TYPES = [
  "Behind Schedule",
  "Missed Pickup",
  "Missed Drop-off"
];
export const RAIL_EXCEPTION_TYPES = ["Idle Train", "Bad Order", "In Hold"];

export function colorForExceptionType(exceptionType) {
  switch (exceptionType) {
    case "Idle Trailer":
      return Colors.highlight.YELLOW;
    case "Behind Schedule":
      return Colors.highlight.YELLOW;
    case "Idle Train":
      return Colors.highlight.YELLOW;
    case "Dweller Shipment":
      return Colors.highlight.YELLOW;
    case "Driver is behind schedule":
      return Colors.highlight.YELLOW;
    case "On Time":
      return Colors.highlight.GREEN;
    default:
      return Colors.highlight.RED;
  }
}

export function textColorForExceptionType(exceptionType) {
  switch (exceptionType) {
    case "Idle Trailer":
      return Colors.text.YELLOW;
    case "Behind Schedule":
      return Colors.text.YELLOW;
    case "Idle Train":
      return Colors.text.YELLOW;
    case "Dweller Shipment":
      return Colors.text.YELLOW;
    case "Driver is behind schedule":
      return Colors.text.YELLOW;
    case "On Time":
    case "Shipment Delivered":
    case "Asset Assigned":
    case "Arrived at Pick Up":
    case "Departed Pick Up":
    case "Arrived at Drop Off":
    case "Departed Drop Off":
      return Colors.highlight.GREEN;
    default:
      return Colors.highlight.RED;
  }
}

export function iconForExceptionType(exceptionType) {
  switch (exceptionType) {
    case "Idle Trailer":
    case "Dweller Shipment":
      return <Hourglass />;
    case "Idle Train":
      return <Hourglass />;
    case "Behind Schedule":
    case "Driver is behind schedule":
      return <Clock />;
    case "Missed Pickup":
    case "Driver has missed the pickup window":
    case "Pickup geofence event missing on in-transit shipment":
    case "Departed Pick Up":
    case "Arrived at Pick Up":
      return <Pickup />;
    case "Missed Drop-off":
    case "Driver has missed the delivery window":
    case "In-transit shipment should have already delivered":
    case "Departed Drop Off":
    case "Arrived at Drop Off":
      return <Dropoff />;
    case "Bad Order":
    case "Invalid Asset - not trackable via telematics provider":
    case "No asset assigned - shipment pickup within 30 minutes or before.":
    case "Shipment has conflicting asset IDs":
    case "Missing manual carrier updates":
    case "Invalid asset - multiple shipments with same asset":
    case "No asset assigned - shipment delivery due soon":
    case "Unassigned shipment should be in-transit":
    case "15 minutes before earliest pickup and not tracking":
    case "Delivered shipment not marked as completed":
      return <Error />;
    case "In Hold":
      return <Lock />;
    case "On Time":
    case "Shipment Delivered":
    case "Asset Assigned":
      return <Check />;
    default:
      return <Error />;
  }
}

// Links to exception types in panel
export const ExceptionLink = props => {
  const {
    shipmentsTotals,
    exceptionType,
    exceptionTypes,
    searchShipments,
    pushSearchView,
    setSearchFilter,
    clearSearchFilters,
    setSearch,
    setSearchCategory,
    site,
    part,
    locations
  } = props;

  const value = shipmentsTotals.details.filter(s => s.key === exceptionType);
  const shipmentsWithException =
    value.length > 0 ? (value[0].count != null ? value[0].count : 0) : 0;

  const handleClick = () => {
    const exceptionEntry = exceptionTypes.filter(e => e.name === exceptionType);
    const exception_code = exceptionEntry.length > 0 ? exceptionEntry[0].id : 0;
    var searchCategory = "everything";
    var searchLabel = "";
    var searchValue = "";
    var searchFilter = {};

    const selected_location = locations
      ? locations.filter(l => l.id === site)
      : [];

    if (selected_location.length === 1) {
      searchCategory = "location";
      searchLabel = selected_location[0].name;
      searchValue = selected_location[0].id;
    } else if (part && part.length > 0) {
      searchCategory = "part_number";
      searchLabel = part;
      searchValue = part;
    }

    clearSearchFilters();
    setSearch(searchLabel, searchValue);
    setSearchCategory(searchCategory);

    if (exception_code > 0) {
      searchFilter = { active_exception: exception_code };
      setSearchFilter("active_exception", exception_code);
    }
    searchShipments({label: searchLabel, value: searchValue}, searchCategory, searchFilter);
    pushSearchView();
  };

  return (
    <glamorous.Div
      onClick={() => handleClick()}
      css={{
        display: "flex",
        flexDirection: "column",
        minWidth: "3em",
        padding: "0.25em",
        paddingTop:0,
        margin: "0.25em",
        fontSize: "x-large",
        border: "1px solid white",
        borderRadius: "5px",
        color: Colors.background.GRAY_BLUE,
        ':hover': {
          border: `1px solid ${Colors.background.GRAY_BLUE}`, 
          backgroundColor: '#fcfcfc',
          cursor: 'pointer',
          boxShadow: `inset 0 0 1px ${Colors.background.GRAY_BLUE}`
        }
      }}
    >
      <glamorous.Div
        css={{
          alignItems: "center"
        }}
      >
        <glamorous.Div css={{ color: textColorForExceptionType(exceptionType), display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          { iconForExceptionType(exceptionType) }
          <glamorous.Div css={{ color: Colors.background.GRAY_BLUE, marginLeft: '5px'}}>
            {shipmentsWithException}
          </glamorous.Div>
        </glamorous.Div>
      </glamorous.Div>
      <glamorous.Div
        css={{
          fontStyle: "italic",
          fontSize: "small",
          color: Colors.background.GRAY_BLUE
        }}
      >
        {exceptionType}
      </glamorous.Div>
    </glamorous.Div>
  );
};

export const ExceptionRow = props => {
  const {
    shipmentsTotals,
    pushSearchView,
    searchShipments,
    exceptionTypes,
    setSearchFilter,
    clearSearchFilters,
    setSearchCategory,
    setSearch,
    locations,
    site,
    part
  } = props;

  const trailerExceptionLinks = TRAILER_EXCEPTION_TYPES.map((e, i) => (
    <ExceptionLink
      key={i}
      shipmentsTotals={shipmentsTotals}
      exceptionType={e}
      pushSearchView={pushSearchView}
      searchShipments={searchShipments}
      exceptionTypes={exceptionTypes}
      setSearchFilter={setSearchFilter}
      clearSearchFilters={clearSearchFilters}
      setSearch={setSearch}
      setSearchCategory={setSearchCategory}
      locations={locations}
      site={site}
    />
  ));
  const railExceptionLinks = RAIL_EXCEPTION_TYPES.map((e, i) => (
    <ExceptionLink
      key={i}
      shipmentsTotals={shipmentsTotals}
      exceptionType={e}
      pushSearchView={pushSearchView}
      searchShipments={searchShipments}
      exceptionTypes={exceptionTypes}
      setSearchFilter={setSearchFilter}
      clearSearchFilters={clearSearchFilters}
      setSearchCategory={setSearchCategory}
      setSearch={setSearch}
      locations={locations}
      site={site}
    />
  ));

  return (
    <glamorous.Div
      css={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <ExceptionDonutChart
        shipmentsTotals={shipmentsTotals}
        locations={locations}
        site={site}
        part={part}
        clearSearchFilters={clearSearchFilters}
        setSearch={setSearch}
        setSearchCategory={setSearchCategory}
        pushSearchView={pushSearchView}
        searchShipments={searchShipments}
      />
      <glamorous.Div
        css={{
          color: Colors.background.DARK_BLUE,
          margin: "1em",
          fontSize: "medium"
        }}
      >
        Trailer Exceptions
        <glamorous.Div css={{ display: "flex", flexDirection: "row", marginLeft: "-0.5em" }}>
          {trailerExceptionLinks}
        </glamorous.Div>
      </glamorous.Div>
      <glamorous.Div
        css={{
          color: Colors.background.DARK_BLUE,
          margin: "1em",
          fontSize: "medium"
        }}
      >
        Rail Exceptions
        <glamorous.Div css={{ display: "flex", flexDirection: "row", marginLeft: "-0.5em" }}>
          {railExceptionLinks}
        </glamorous.Div>
      </glamorous.Div>
    </glamorous.Div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/exceptions/ExceptionLink.js